import { graphql, useStaticQuery } from 'gatsby';
import { IGatsbyImageData } from "gatsby-plugin-image"


interface Marker {
  title: string;
  description: {
    description: string;
  };
}

interface ProductData {
  products: {
    nodes: Product[]
  }
}

// temporary workaround on data fetch
const useFindManyProducts = ({ productIds }: { productIds: number[] }) => {
  const data: ProductData = useStaticQuery(graphql`
    query {
      products: allContentfulProduct(filter: { productId: { nin: [null] } }) {
        nodes {
          id
          productId
          displayName
          longDescription {
            longDescription
          }
          shortDescription
          productCardImage {
            gatsbyImageData(layout: FULL_WIDTH)
          }
          boxImage {
            gatsbyImageData(layout: FULL_WIDTH)
          }
          markerList {
            markers {
              title
              description {
                description
              }
            }
          }
        }
      }
    }
  `);
  // Return the first Product per ProductID
  let res = [] as Product[];
  [...new Set(productIds)].forEach((productId) => {
    const product = data?.products?.nodes?.find(({ productId: id }) => id === productId)
    if (product) {
      res.push(product)
    }
  });
  return (res);
};

export default useFindManyProducts;
